import PropTypes from 'prop-types'

import {
  Box,
  CoverImage,
  Icon,
  Heading,
  Label,
  Text,
  TransparentButton,
} from '@redriverpress/system'

import { LessonShape } from '../constants/VideoPropType'

export default function LessonCard({ lesson }) {
  return (
    <TransparentButton
      as='a'
      href={`/routes/lesson/${lesson.id}`}
      p={[2, null, 3]}
      bg='white'
      display='flex'
      alignItems='top'
      flex='1 0 100%' // match height row
      mb={2}
      borderRadius='rounded'
      boxShadow={2}
    >
      <CoverImage src={lesson.thumbnail_url} size={['3rem', null, '5rem']} />
      <Box flex='1' pl={[2, null, 3]} fontSize={0}>
        {lesson.teacher_discretion && (
          <Label compact type='warning' mb={1}>
            <Icon icon='exclamation-triangle' pr={2} />
            Teacher Discretion
          </Label>
        )}
        <Text color='gray700' fontWeight={600} mb={1}>
          Lesson
        </Text>
        <Heading as='h5' mb={1} pr={4}>
          {lesson.title}
        </Heading>
        <Text mb={2}>{lesson.lesson_section_title}</Text>
        <Box display='flex' alignItems='center'>
          <Icon icon='lightbulb' pr={2} />
          {lesson.level_display}
        </Box>
      </Box>
    </TransparentButton>
  )
}

LessonCard.propTypes = {
  lesson: PropTypes.shape(LessonShape).isRequired,
}
